import React, { useState } from 'react';
import { handleCancelSubscription } from '../../common/subscription/SubscriptionService';
import {
  Stack,
  Typography,
  CircularProgress,
  Box,
  Button,
  Paper,
} from '@mui/material';
import { styled } from '@mui/system';
import { showSuccessSnackbar } from '../../common/snackbar/SnackbarActions';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
}));

const LeftItem = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
  width: '98%',
  textAlign: 'left',
}));

export default function CancelSubscriptionForm({ callback = () => {} }) {
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const confirmButtonClick = () => {
    setIsSubmitting(true);
    handleCancelSubscription()
      .then(() => {
        showSuccessSnackbar('Your subscription has been canceled');
        setIsSubmitting(false);
        callback();
      })
      .catch((err) => {
        console.error(err);
        setErrorMessage(err.message);
        setIsSubmitting(false);
      });
  };

  return (
    <Stack alignItems='center' justifyContent='center'>
      <LeftItem>
        <Typography>
          <QuestionMarkIcon
            sx={{ color: 'primary.main' }}
            style={{ verticalAlign: 'middle' }}
          />
          Please confirm that you would like to cancel your subscription. No
          further payments will be charged and you will lose access to the
          LINKtivity Library at the end of your current billing period.
        </Typography>
      </LeftItem>
      {errorMessage && (
        <LeftItem>
          <Typography sx={{ color: 'error.main' }}>{errorMessage}</Typography>
        </LeftItem>
      )}
      <Item>
        <Box sx={{ m: 1, position: 'relative' }}>
          <Button
            disabled={isSubmitting}
            variant='contained'
            onClick={confirmButtonClick}
          >
            <SaveIcon style={{ marginRight: '5' }} />
            Confirm
          </Button>
          {isSubmitting && (
            <CircularProgress
              size={24}
              sx={{
                color: 'secondary.main',
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-9px',
                marginLeft: '-12px',
              }}
            />
          )}
        </Box>
        <Button
          type={'reset'}
          color='secondary'
          disabled={isSubmitting}
          variant='contained'
          onClick={callback}
        >
          <CancelIcon style={{ marginRight: '5' }} />
          Back
        </Button>
      </Item>
    </Stack>
  );
}
